import { useMemo } from 'react';
import { useNodes } from 'reactflow';

import { FeatureFlag, useFeatureFlags } from '../feature-flags';
import { useFlowCanvas } from './state';
import type { AiBlockNodeData, AppNodeData, PathNodeData } from './types';

export const useNodeData = <T = AppNodeData | AiBlockNodeData | PathNodeData, U = object>() => {
  const { selectedNodeId, newNodeData } = useFlowCanvas();

  const nodes = useNodes();

  const nodeData = useMemo(() => {
    if (selectedNodeId) {
      const node = nodes.find((n) => n.id === selectedNodeId);

      if (node) {
        return node.data as T & U;
      }
    }
    return newNodeData as Partial<T & U>;
  }, [selectedNodeId, nodes, newNodeData]);

  return nodeData;
};

export const useCustomCodeActionFeatureFlag = () => useFeatureFlags(FeatureFlag.CUSTOM_CODE_ACTION);
export const useCustomCodeLiveEditorFeatureFlag = () => useFeatureFlags(FeatureFlag.CUSTOM_CODE_LIVE_EDITOR);
export const useGSheetsFeatureFlag = () => useFeatureFlags(FeatureFlag.GOOGLE_SHEETS_INTEGRATION);
export const useDuplicateFlowFeatureFlag = () => useFeatureFlags(FeatureFlag.DUPLICATE_FLOW);
